import { router } from '@/app/router';
import { detectPlatform } from './detect';
import { Platform } from './types';

const UNIVERSAL_LINK_HOSTS = new Set(['infiltre.mtro.fr']);
const CUSTOM_SCHEME = 'infiltre:';

type DeeplinkTarget = { kind: 'room'; code: string };

// Supported shapes:
//   infiltre://room/<code>   |  infiltre://r/<code>
//   https://infiltre.mtro.fr/room/<code>  |  https://infiltre.mtro.fr/r/<code>
export function resolveDeeplink(rawUrl: string): DeeplinkTarget | null {
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    return null;
  }

  if (url.protocol === CUSTOM_SCHEME) {
    // Custom scheme: host carries the first segment (infiltre://room/ABC → host=room, path=/ABC).
    return mapSegments([url.host, ...url.pathname.split('/').filter(Boolean)].filter(Boolean));
  }

  if ((url.protocol === 'https:' || url.protocol === 'http:') && UNIVERSAL_LINK_HOSTS.has(url.host)) {
    return mapSegments(url.pathname.split('/').filter(Boolean));
  }

  return null;
}

function mapSegments(segs: string[]): DeeplinkTarget | null {
  const [head, code] = segs;
  if ((head === 'r' || head === 'room') && code) return { kind: 'room', code };
  return null;
}

export const initDeeplinkListener = (): void => {
  if (detectPlatform() !== Platform.Capacitor) return;

  void (async () => {
    try {
      const { App } = await import('@capacitor/app');
      await App.addListener('appUrlOpen', ({ url }) => {
        const target = resolveDeeplink(url);
        if (target?.kind === 'room') {
          void router.navigate({ to: '/room/$code', params: { code: target.code }, replace: true });
        }
      });
    } catch {
      // @capacitor/app missing in this build — ignore.
    }
  })();
};
